import { Badge, FlexLayout, H4, Icon } from '@deity/falcon-ui';
import type { FC } from 'react';

interface MappingStatsProps {
  mappingCount: number;
  processorCount: number;
  fieldsWithProcessor: number;
  mappedRequiredField: number;
  requiredTargetField: number;
}
export const MappingStats: FC<MappingStatsProps> = ({
  mappingCount,
  processorCount,
  fieldsWithProcessor,
  mappedRequiredField,
  requiredTargetField
}) => {
  const notMappedRequiredFields = requiredTargetField - mappedRequiredField;

  return (
    <FlexLayout
      p="md"
      borderRadius="small"
      boxShadow="subtle"
      bg="white"
      css={{ width: '230px', position: 'absolute', left: 'calc(50% - 115px)' }}
    >
      <FlexLayout flexWrap="nowrap">
        <Icon src="accountTreeRounded" color="primary" stroke="transparent" mr="xs" />
        <FlexLayout>
          <H4 fontWeight="bold">{mappingCount} MAPPINGS</H4>
          <H4 mt="xs" color="secondary" fontSize="xs" fontWeight="bold">
            REQUIRED TARGET
          </H4>

          <H4 mt="xs" color="secondary" fontSize="xs" fontWeight="bold">
            <Badge variant="round" bg="lightGrey">
              {mappedRequiredField}
            </Badge>
            /
            <Badge variant="round" bg="lightGrey" mr="xs">
              {requiredTargetField}
            </Badge>
            MAPPED
          </H4>
        </FlexLayout>
      </FlexLayout>
      <FlexLayout flexWrap="nowrap" mt="xs">
        <Icon src="shuffle" color="primary" stroke="transparent" mr="xs" />
        <FlexLayout>
          <H4 fontWeight="bold">{processorCount} PROCESSOR</H4>
          <H4 mt="xs" color="secondary">
            On
            <Badge variant="round" bg="lightGrey" mr="xs" ml="xs">
              {fieldsWithProcessor}
            </Badge>
            field{fieldsWithProcessor > 1 ? 's' : ''}
          </H4>
        </FlexLayout>
      </FlexLayout>
      {notMappedRequiredFields > 0 && (
        <FlexLayout alignItems="center" flexWrap="nowrap" mt="xl" css={{ position: 'absolute', bottom: -50, left: 0 }}>
          <Icon src="warningOutlined" color="transparent" stroke="warningDark" mr="xs" />
          <H4 fontSize="sm" color="warningDark">
            {notMappedRequiredFields} Required field{notMappedRequiredFields > 1 ? 's' : ''} not mapped
          </H4>
        </FlexLayout>
      )}
    </FlexLayout>
  );
};
